import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SystemBanner } from "../../../components/UIToolkit/molecules/SystemBanner";
import SystemButton from "../../../components/UIToolkit/SystemButton/SystemButton";

type Props = {
	/** The viewed day failed (only reopening helps), rather than the chosen printout (which can be tried again). */
	dayFailed: boolean;
	onRetrySource: () => void;
};

/** In place of the preview when the day or the chosen printout couldn't load. */
export const CustomPrintoutLoadError: FC<Props> = ({ dayFailed, onRetrySource }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ flex: 1, minWidth: 0 }}>
			<SystemBanner
				dataTestId="custom-printout-load-error"
				tone="error"
				title={t(dayFailed ? "printout.custom.ai.load.failed" : "printout.custom.ai.printout.load.failed")}
				action={
					dayFailed ? undefined : (
						<SystemButton data-testid="custom-printout-load-retry" buttonVariant="secondary" size="small" noFullWidthMobile onClick={onRetrySource}>
							{t("retry")}
						</SystemButton>
					)
				}
			/>
		</Box>
	);
};
